export const getReviews = (count) => {
  const shuffled = [...reviewsList].sort(() => 0.5 - Math.random())
  return shuffled.slice(0, count)
}

export const reviewsList = [
  {
    name: 'Marleigh Savage-Mansfield',
    time: 'a year ago',
    content: `They were very timely, cleaned up perfectly, did a great job, polite and friendly, and the price was reasonable. We will definitely use them again. Thanks, Guys!`
  },
  {
    name: 'Carol Hill',
    time: '1 year ago',
    content: `Daniel dug up a hedge of tall forsythia in my yard. He hauled away all the stumps, branches, and roots and left my yard clean and free of debris. I would highly recommend Clark Tree Service......he did an outstanding job.`
  },
  {
    name: 'Yevheniy Burshteyn',
    time: '5 months ago',
    content: 'Great service! Highly recommend!'
  },
  {
    name: 'Raymond Wu',
    time: '7 months ago',
    content:
      'Fair price and great service of the entire team were impressive, and Clark Tree Services is highly recommended for any needing tree care services.'
  },
  {
    name: 'Phil Levinton',
    time: '9 months ago',
    content: `We used Clark Tree Services to remove some tree limbs - one of which was quite large and hanging over our neighbor's fence. Daniel did a thorough diagnosis of the situation, and recommended and afterwards executed a plan for solving the problem. We are very pleased with the results.`
  },
  {
    name: 'M Strolle',
    time: 'a year ago',
    content: `Clark Tree Services is the best! I wouldn't use any other tree service. I've been using them for years and they always do an exemplary job. I highly recommend them.`
  },
  {
    name: 'James Savitz',
    time: 'a year ago',
    content:
      'Clark Tree Services is an amazing company. The quality of their work is exceptional and their prices are extremely reasonable. I highly recommend them.'
  },
  {
    name: 'Carol Hill',
    time: 'a year ago',
    content:
      'Daniel dug up a hedge of tall forsythia in my yard. He hauled away all the stumps, branches, and roots and left my yard clean and free of debris. I would highly recommend Clark Tree Service......he did an outstanding job.'
  },
  {
    name: 'I C',
    time: 'a year ago',
    content: `We used Clark Tree Services again to remove a large cherry tree and trim some tree branches at our son's house due to our positive experience with them 3 years ago. Dan and his team showed up on time and worked non-stop for about 3 hours. They had all the right equipment to cut the tree and grind the roots. They completed all tasks efficiently and kept the site neat and clean after the job. They piled up the shredded tree mulches per our request for various landscaping uses. We had another positive experience with Dan and his crew again. Their price was very reasonable. Highly recommended!!`
  },
  {
    name: 'I C',
    time: 'a year ago',
    content:
      'Clark Tree removed several trees including a 50 foot tall wild tree from my yard this week. The owner Dan and his crew came early in the morning and worked very efficiently. They are true professionals, clean and polite. The total cost was very reasonable and slightly less than one other estimate but significantly lower than two other estimates from equally high rated local tree companies. I decided to have them remove three other small trees on the spot and his price was also very reasonable. They left my place very clean afterward. I already recommended them to several friends in need of tree services. Clark Tree is an honest small local business. Highly recommended!!'
  },
  {
    name: 'Emily Kim',
    time: 'a year ago',
    content: 'Great service and reasonable price.'
  },
  {
    name: 'Patti Nichols',
    time: 'a year ago',
    content:
      'Daniel and his crew are fantastic to work with! Have been using Clark Tree Services for years and I am always satisfied with the work they do.'
  },
  {
    name: 'Bob McCartin',
    time: 'a year ago',
    content:
      'I asked Clark to trim 3 of my trees. They came on time, trimmed the trees as requested, and cleaned up so that nothing was left for me to do. The price was competitive. This was my second experience with Clark. I would use them again and recommend them to those who ask.'
  },
  {
    name: 'Marleigh Savage-Mansfield',
    time: 'a year ago',
    content:
      'They were very timely, cleaned up perfectly, did a great job, polite and friendly, and the price was reasonable. We will definitely use them again. Thanks, Guys!'
  },
  {
    name: 'Sharon Gearhart',
    time: 'a year ago',
    content:
      'I am very pleased with the work provided by Clark Tee Services. The office personnel were professional and courteous. Quotes were competitive and were delivered in a timely matter. The tree removal team arrived promptly on date.'
  },
  {
    name: 'Gary Lin',
    time: 'a year ago',
    content:
      'Great service. Daniel was pleasant to talk to when he came out to the house. The tree and bamboo were cleared and the area nicely cleaned up. Thank you and will use your services again.'
  },
  {
    name: 'Lizabeth Coppock',
    time: 'a year ago',
    content: `100% recommend! Super happy with Clark Tree’s service. I had quite the list of items to address; some where I needed a bit (actually, a lot!) of guidance. Daniel was able to lend his expertise to give me great recommendations on what to do and he did so at a very reasonable price. He and his team did a great job on the day of service; which he reviewed with me upon completion of the jobs. Debbie was so enjoyable to work with for help with the quotes and scheduling. I definitely recommend this company and will be keeping them in my contacts for any future projects!`
  },
  {
    name: 'Larry C',
    time: 'a year ago',
    content:
      'Daniel removed a large hickory that had fallen on our property. His price was reasonable and he did the work in a timely fashion. The area was left clean and neat. Thanks, Daniel!'
  },
  {
    name: 'R S',
    time: '2 years ago',
    content: `Daniel and his crew did a great job. He and his crew removed a large oak tree that was difficult to access in the back corner of our yard. He had the tree out, stump ground and area cleaned exactly as promised. Deborah in his office was also terrific to work with. Excellent communication, great workmanship and fair prices. I'd highly recommend calling Clark Tree Services.`
  },
  {
    name: 'Dean Graves',
    time: '2 years ago',
    content:
      'Clark completed the removal of two huge trees as promised. They arrived as scheduled, removed a 28” Norway spruce and 18” Pin oak, cleaned up ALL the debris perfectly. Awesome job at a reasonable price. I highly recommend Clark for any arborist work.'
  },
  {
    name: 'Sharon Doyle',
    time: '2 years ago',
    content:
      'Excellent quality work, excellent staff & excellent pricing. They trimmed hollies, red twig, and other shrubs at my place of worship and also removed a dead tree. Extremely happy! Highly recommend Clark Tree Service.'
  },
  {
    name: 'Geoff Tomasetti',
    time: '2 years ago',
    content:
      'Dan and his crew are very efficient and cost effective. When they were done with their job is was cleaned up extremely well.'
  },
  {
    name: 'Joan Weller',
    time: '2 years ago',
    content: `I just had two days of tree work done by Clark Tree service. Dan and Mike did a great job. This work involved the removal of three trees - a 60ft Pin Oak and two dead 40' trees. Dan then majorly trimmed a very large 60' Sawtooth Oak to keep it away from the house, a large 30' Deodora Cedar, as well as 4 Bradford pears and a Nellie Stevens Holly (15ft). I was totally impressed. He had the right tools for each job. The work flowed seamlessly and efficiently. I usually need about two days of tree work done each year so I have a lot of past experience with tree companies. I was very satisfied with how effectively Dan pruned the Deodora Cedar and the very large Sawtooth oak . He has every piece of equipment he needs from a bucket truck to a stump grinder, chipper, the longest pole saws and pruners that I have every seen as well as a large truck to lift and haul away all the wood. Dan and Mike were very pleasant and easy to work with. Dan responded to my requests and explained what he was doing throughout the process. Mike constantly chipped the wood. I felt the estimate which included everything including the stump grinding was fair for the amount of work and quality of work done. I will definitely use Clark Tree Service again.`
  },
  {
    name: 'Thom Weaverling',
    time: '2 years ago',
    content: 'Daniel and team were great!'
  },
  {
    name: 'Lindsey Peller',
    time: '2 years ago',
    content:
      'Clark Tree Service did a wonderful job removing unwanted trees from our back yard. They are easy to work with and great with communication. I would highly recommend them!'
  },
  {
    name: 'Sandy Olsen',
    time: '2 years ago',
    content: 'Very professional a great experience.'
  },
  {
    name: 'Jake Moloznik',
    time: '2 years ago',
    content: `Dan and his team were quick to come survey and provide an estimate of work. We're accommodating to scheduling service. Worked efficiently and left the yard clean as if they were never there.`
  },
  {
    name: 'Faith Frankel',
    time: '2 years ago',
    content:
      'Daniel and his crew are incredible! Property left cleaned up, they work fast and efficient and prices are very fair. They are our go to tree company.'
  },
  {
    name: `Amy D'Elia`,
    time: '2 years ago',
    content:
      'I had a great experience with Clark Tree Service last week. I highly recommend Daniel and his crew!!! They were on time, professional, a great value and very responsive. I will call them again for any tree needs.'
  },
  {
    name: 'Mariusz S',
    time: '2 years ago',
    content:
      'Professional, timely, responsive, and patient. I would definitely recommend Clark Tree Services to a friend and plan to engage their services in the future.'
  },
  {
    name: 'Jesse Meng',
    time: '2 years ago',
    content:
      'Daniel was great! Excellent service and good price. Highly recommended.'
  },
  {
    name: 'Bridgette D',
    time: '2 years ago',
    content: 'Always exceeds expectations!'
  },
  {
    name: 'Karen Yarrick',
    time: '2 years ago',
    content:
      'They were here for about 2 hrs and the tree, stump and stubborn roots were gone. They did a great job. Recommended company to my HOA as a suggested company.'
  },
  {
    name: 'Edward Chung',
    time: '2 years ago',
    content: `Clark Tree Services did a great job the first time and we hired them to take down another already decaying tree in our yard. Pine trees can be a pain and especially when they have expired.
      
We were scheduled for a week or two out but they managed to fit us in sooner. Mr. Clark and his team were professional, timely and efficient.

Clean up a was breeze and they worked non stop. They also did a brief inspection to let us know of potential problems in the future regarding tree hazards.

If anyone needs tree services, we will always recommend Clark Tree Services. They are so great that all our neighbors use them too!

Competitive pricing and quality work. We have high confidence in their workmanship, customer service and professionalism.`
  },
  {
    name: 'Vlad L',
    time: '2 years ago',
    content:
      'Excellent tree service. We have been using their services for years.'
  },
  {
    name: 'R Redlack',
    time: '2 years ago',
    content: 'Service was excellent and Daniel and crew were great.'
  },
  {
    name: 'Brian Murphy',
    time: '2 years ago',
    content: 'Great job as usual by Daniel and his guys.'
  },
  {
    name: 'Scott Orkin',
    time: '2 years ago',
    content: 'Would not hesitate to use again.'
  },
  {
    name: 'Jeff Woo',
    time: '2 years ago',
    content:
      'Daniel was able to get a Bid promptly and it was very competitive. Debbie was nice and able to answer questions. Trimming was as we agreed upon. Will use again.'
  },
  {
    name: 'Tim Nee',
    time: '2 years ago',
    content: `Daniel has been pruning our trees for many years. He does an excellent job and always at a fair price. Daniel cares about our trees and would tell us when something doesn't need to be done. He and the crew cleans everything up. Debbie is a pleasure to work with. We're very happy to have found such a wonderful local family run business.`
  },
  {
    name: 'Thomas Fuerst',
    time: '2 years ago',
    content:
      'Dan and his crew did a great job. Very responsive, careful, and on time.'
  },
  {
    name: 'Manju Dinesh Gupta',
    time: '2 years ago',
    content:
      'Excellent service. Used the company for removal of a tree and stump grinding. I recommend it without any reservation.'
  },
  {
    name: 'George Serafino',
    time: '2 years ago',
    content:
      'Superlative quality and cost compared to other companies I have used in the past 25 years. My pleasure to support local business here in Darnestown. Dan was extremely prompt and efficient in the 3 jobs that I gave him this past spring, so much so that he arrived and completed the jobs (with no debris left behind) before I even got up in the morning! Highly recommended for tree trimming and removal jobs both large and small.'
  },
  {
    name: 'Maggie Newcomer',
    time: '2 years ago',
    content:
      'Daniel and crew were amazing and professional. They removed 3 very large trees and 1 small tree from our property for a really great price. One of the trees was almost horizontal over the neighbors yard and very dangerous to remove, Daniel got it down without damaging any of the surrounding landscaping or any injuries. They removed all of the debris and cleaned up the yard and driveway. I would highly recommend Clark Tree Services. Pictures are during the removal and after the cleanup.'
  },
  {
    name: 'Edward C',
    time: '2 years ago',
    content:
      'Great local and professional tree services. Hard working and timely. They came and even through pouring rain they pressed on to deliver quality service. Would recommend to all and would use again. Our neighbors used them to take down two LARGE pine trees and they did a fantastic job as well.'
  },
  {
    name: 'Rebecca Weisman',
    time: '3 years ago',
    content:
      'On time. Very professional, skilled, and safe. Efficient and thorough. Very competitive pricing. Great experience.'
  },
  {
    name: 'Andrew',
    time: '3 years ago',
    content:
      'They did a good and job and very reasonable price. They took out 6 skinny trees and pruned one tree. I would use them again.'
  },
  {
    name: 'kok fong',
    time: '3 years ago',
    content:
      'Positive. Responsiveness, Punctuality, Quality, Professionalism, Value. Services. Tree removal.'
  },
  // {
  //   name: 'Rosemary DeRose',
  //   time: '3 years ago',
  //   content: `Daniel. We appreciate you so much for the great job in the RCES courtyard in preparation for Todd's eagle project to revitalize the space. As a former Eagle Scout yourself, it is wonderful that you continue to give back to the scout program and support the community! Thanks again, Rosemary DeRose.`
  // },
  {
    name: 'Tyler Mosman',
    time: '3 years ago',
    content:
      'Clark Tree Service was recommended to me by someone in my community and I will be recommending him to my friends and neighbors.'
  },
  {
    name: 'Joe Schauder',
    time: '4 years ago',
    content:
      'On time, on budget, and on schedule. Very professional and took care of everything I asked for. Will likely have them out again next year for another part of my yard. Great job!'
  },
  {
    name: 'Rob Kasunic',
    time: '4 years ago',
    content:
      'Daniel and his crew do outstanding work for very reasonable prices. They are professional, friendly, and go above and beyond. I have returned to Daniel for many years now and have always been happy with his work. I highly recommend him.'
  },
  {
    name: 'G Kaplan',
    time: '5 years ago',
    content:
      'We recently had Clark Trees remove 7 very large trees from our property. We were very impressed by their level of professionalism, especially the way that they cleaned up each day, our yard and our neighbors yards where debris had landed. Out of 5 estimates, they were the cheapest too. Highy recommend.'
  },
  {
    name: 'Sarah Armour',
    time: '5 years ago',
    content: `I am very pleased with the work that Daniel did at Clark's Tree Service. He showed up on time and he and his crew did the work quickly and thoroughly. I'm very happy with the estimate on the work that I received. I would not hesitate to use Clark's Tree Service again in the future. And, I would not hesitate to recommend them to anybody, in fact I would highly recommend them.`
  },
  {
    name: 'Thomas Perc',
    time: '6 years ago',
    content: `Quality work performed by skilled, trustworthy team. Very responsive to RFPs. Patient and persistent in dealing with multiple parties (HOA, neighbors, owners, tenants, management companies, local government.) Can't Go wrong.`
  },
  {
    name: 'Jenny Wren',
    time: '6 years ago',
    content:
      'Absolutely amazing service!!! These folks were taking down a sizable maple tree. Before I knew it they were there, done, cleaned up, and gone in what seemed like the blink of an eye!'
  },
  {
    name: 'Lijin Dong',
    time: '6 years ago',
    content: 'Great service. Strongly recommend.'
  }
]
